// extracted by mini-css-extract-plugin
module.exports = {"static-page-header-actions":"header_static-page-header-actions__1hvhV"};